// extracted by mini-css-extract-plugin
module.exports = {"card":"PriceHasChanged_card__1wwg4","paragraph":"PriceHasChanged_paragraph__1eoB7"};